import { MenuItem } from '@mui/material';
import { handleExportCsv } from './helpers';

export function FileDownloader({ columnsForExport, title, onClose }) {
  const handleClick = () => {
    handleExportCsv(columnsForExport, title);
    onClose();
  };

  return (
    <MenuItem onClick={handleClick}>Download da Planilha</MenuItem>
  );
}
